<div class="card m-4" *ngIf="quoteService.quote.value?.Payment_Processing_Rate__r">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Payment Processing Services</div>
	</div>
	<p-divider></p-divider>
	<div class="p-grid">
		<div class="col-6 p-md-3">
			<div class="d-flex">
				<fa-icon [icon]="['fab', 'cc-visa']" size="2x" class="mt-1 ms-auto"></fa-icon>
				<fa-icon [icon]="['fab', 'cc-mastercard']" size="2x" class="mt-1 ms-auto"></fa-icon>
				<fa-icon [icon]="['fab', 'cc-discover']" size="2x" class="mt-1 ms-auto"></fa-icon>
			</div>
		</div>
		<div class="col-6 p-md-3">
			<div class="h-100 d-flex">
				<div class="my-auto mx-1 line-item-description">
					{{ quoteService.quote.value.Payment_Processing_Rate__r.VMCD_Bin_Rate__c | percent: "0.0-5" }} /
					{{ quoteService.quote.value.Payment_Processing_Rate__r.VMCD_Tran_Fee__c | currency }}
				</div>
			</div>
		</div>
		<div class="col-6 p-md-3">
			<div class="d-flex h-100">
				<fa-icon [icon]="['fab', 'cc-amex']" size="2x" class="mt-1 ms-auto"></fa-icon>
			</div>
		</div>
		<div class="col-6 p-md-3">
			<div class="h-100 d-flex">
				<div class="my-auto mx-1 line-item-description">
					{{ quoteService.quote.value.Payment_Processing_Rate__r.AMEX_Bin_Rate__c | percent: "0.0-5" }} /
					{{ quoteService.quote.value.Payment_Processing_Rate__r.AMEX_Tran_Fee__c | currency }}
				</div>
			</div>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-12 p-md-4">
			<div class="d-flex flex-column m-3">
				<div class="mx-auto line-item-description">Batch Fee</div>
				<div class="mx-auto line-item-description">{{ quoteService.quote.value.Payment_Processing_Rate__r.Batch_Fee__c | currency }}</div>
				<div class="item-detailed-description text-center">The batch fee is charged for each daily batch to facilitate next-day funding services.</div>
			</div>
		</div>
		<div class="p-col-12 p-md-4">
			<div class="d-flex flex-column m-3">
				<div class="mx-auto line-item-description">Device Warranty</div>
				<div class="mx-auto line-item-description">{{ quoteService.quote.value.Payment_Processing_Rate__r.Device_Fee__c | currency }}</div>
				<div class="item-detailed-description text-center">
					We charge a per-device warranty charge to cover the cost of next-day replacement of your payment device. If your device fails, we take care
					of it.
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-4">
			<div class="d-flex flex-column m-3">
				<div class="mx-auto line-item-description">Monthly Fee</div>
				<div class="mx-auto line-item-description">{{ quoteService.quote.value.Payment_Processing_Rate__r.Monthly_Service_Fee__c | currency }}</div>
				<div class="item-detailed-description text-center">
					Monthly service charge covers statement fees, backend processing fees and any other non-transaction fees that may be incurred.
				</div>
			</div>
		</div>
	</div>
	<div class="d-flex item-detailed-description text-center">
		{{ quoteService.quote.value.Payment_Processing_Rate__r.Rate_note__c }}
	</div>
</div>
